import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { TranslateService } from '@ngx-translate/core';
import { AttachmentStore } from '../service/attachment/attachment.store';
import { Attachment } from '../models/attachment';
import { List } from 'immutable';

@Injectable()
export class PickupReportAttachmentResolver implements Resolve<any> {
  constructor(private attachmentStore: AttachmentStore,
              private translateService: TranslateService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<List<Attachment>> {
    const id = route.params[ 'id' ];
    const eventPartyId = route.params[ 'eventPartyId' ];

    if (!id) {
      throw new Error(this.translateService.instant('MESSAGES.ERROR.GET_EVENT'));
    }

    if (eventPartyId) {
      return this.attachmentStore.getAttachmentsByParty(id, eventPartyId).first();
    } else {
      return this.attachmentStore.getAttachments(id).first();
    }
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/pickup-report-attachment/pickup-report-attachment.resolver.ts